import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"selectorGrid":"styles_selectorGrid__hDU4+","gridCell":"styles_gridCell__sByEn"};
export const b = b_.with('selectorGrid');